import { render, staticRenderFns } from "./ProductSearchResults.vue?vue&type=template&id=0a449271&scoped=true"
import script from "./ProductSearchResults.vue?vue&type=script&lang=js"
export * from "./ProductSearchResults.vue?vue&type=script&lang=js"
import style0 from "./ProductSearchResults.vue?vue&type=style&index=0&id=0a449271&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a449271",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QPopupEdit from 'quasar/src/components/popup-edit/QPopupEdit.js';
import QField from 'quasar/src/components/field/QField.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QForm from 'quasar/src/components/form/QForm.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QExpansionItem,QCircularProgress,QSpace,QChip,QCardActions,QBtn,QToggle,QInput,QTable,QTr,QTd,QTooltip,QIcon,QBadge,QPopupEdit,QField,QSeparator,QDialog,QForm});qInstall(component, 'directives', {ClosePopup});
